import React from "react";
import { Table } from "@mui/material";

// Shared visual treatment; callers retain server-side data loading and paging.
export default function DataTable({ sx = [], ...props }) {
  return <Table {...props} sx={[
    {
      "& th": { fontSize: 10, textTransform: "uppercase", letterSpacing: "0.08em", bgcolor: "action.hover", py: 1.25 },
      "& td": { fontSize: 13, py: 1.75 },
    },
    ...(Array.isArray(sx) ? sx : [sx]),
  ]} />;
}
